export default __webpack_public_path__ + "static/media/ade-default-product.54c7ece2.png";